import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SvgCommonModule } from '../../../shared/svg/svg-common.module';
import { UiModule } from '../../ui.module';

import { GoodbyeIeComponent } from './goodbye-ie.component';

@NgModule({
	imports: [
		CommonModule,
		UiModule,
		SvgCommonModule,
	],
	declarations: [GoodbyeIeComponent],
	exports: [GoodbyeIeComponent],
})

export class GoodbyeIeModule { }
